import Vue from 'vue';
import { ValidationObserver, ValidationProvider, setInteractionMode, extend, localize } from 'vee-validate';

// eslint-disable-next-line @typescript-eslint/camelcase
import { required, min, max, email, min_value, max_value, between } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import ru from 'vee-validate/dist/locale/ru.json';

export type ValidationObserver = InstanceType<typeof ValidationObserver>;

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

localize({ ru, en });
localize('ru');

setInteractionMode('eager');

extend('required', required);
extend('min', min);
extend('max', max);
extend('email', email);
extend('min_value', min_value);
extend('max_value', max_value);
extend('between', between);
